import React from 'react'
import PropTypes from 'prop-types'
import { MenuItem, Select, Typography } from '@mui/material'
import { PERMISSION_DOMAINS, PERMISSION_LEVELS } from './permissionsConfig'

// Per-domain access-level picker. `levels` maps domain key -> '' | level.
const PermissionPicker = ({ levels, onChange }) => {
  return (
    <>
      <Typography variant='body2' className='text-gray-500 mb-3'>
        Choose the access level for each area. Higher levels include the ones below.
      </Typography>
      {PERMISSION_DOMAINS.map(domain => (
        <div key={domain.key} className='flex items-center justify-between mb-3'>
          <span>{domain.label}</span>
          <Select
            size='small'
            style={{ minWidth: 160 }}
            value={levels[domain.key]}
            displayEmpty
            onChange={e => onChange(domain.key, e.target.value)}
          >
            <MenuItem value=''>No access</MenuItem>
            {PERMISSION_LEVELS.map(level => (
              <MenuItem key={level} value={level}>
                {level.charAt(0).toUpperCase() + level.slice(1)}
              </MenuItem>
            ))}
          </Select>
        </div>
      ))}
    </>
  )
}

PermissionPicker.propTypes = {
  levels: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
}

export default PermissionPicker
